<div class="app-container">
  <toolbar></toolbar>
  <progress-bar></progress-bar>
  <banner></banner>
  <div class="app-contents">
    <router-outlet></router-outlet>
  </div>
</div>
